export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

export const networkErrorCodes = [53000, 53001, 53002, 53204, 53405];
